import React from 'react'
import { useParams } from 'react-router-dom'
import TenantDetails from "./TenantDetails"

const TenantDetailsWrapper = (props) => {
    const params = useParams()
    return <TenantDetails {...props} params={params} />
}

export default TenantDetailsWrapper
